const endPointPath = {
  calendar       : 'https://www.googleapis.com/calendar/v3/calendars/',
  email          : 'https://script.google.com/macros/s/',
  emailOrder     : 'https://gaelleboudier.com/serve/index.php/sendorder',
  getTemplates   : 'https://www.gaelleboudier.com/serve/index.php/templates',
  login          : 'https://www.gaelleboudier.com/serve/index.php/login',
  setTemplatesEn : 'https://www.gaelleboudier.com/serve/index.php/updateen',
  setTemplatesFr : 'https://www.gaelleboudier.com/serve/index.php/updatefr',
};

export default endPointPath;



// WEBPACK FOOTER //
// ./src/global/endPointPath.js